import cn from 'clsx';
import {useTranslation} from 'next-i18next';
import PropTypes from 'prop-types';
import React from 'react';
import CustomSelect, {components} from 'react-select';

import DDIcon from '@/public/icons/dropDownIndicator.svg';
import DDIconWhite from '@/public/icons/dropDownIndicatorWhite.svg';
import useIsMobile from '@/src/hooks/useIsMobile';
import {useTheme} from '@/src/hooks/useTheme';

import css from '../styles/styles.module.css';
import {getCustomStyles} from './Select';

export const DropdownIndicator = (props) => {
  const {isFocused} = props;
  const {isDarkMode} = useTheme();

  return (
    <components.DropdownIndicator {...props}>
      <div
        className={cn(css.selectIcon, {
          [css.selectIconFocused]: isFocused,
        })}
      >
        {isDarkMode ? <DDIconWhite /> : <DDIcon />}
      </div>
    </components.DropdownIndicator>
  );
};

DropdownIndicator.propTypes = {
  isFocused: PropTypes.bool,
};

const SimpleSelect = ({
  options,
  maxMenuHeight,
  placeholder,
  onChange,
  value,
  noOptionsMessage,
  isDisabled,
  size,
  isError,
}) => {
  const {isMaxWidth900} = useIsMobile();
  const {t} = useTranslation('common');
  const {isDarkMode} = useTheme();

  return (
    <div className={cn(css.select, {})}>
      <CustomSelect
        isDisabled={isDisabled}
        className="select"
        styles={getCustomStyles(isMaxWidth900, size, isError, isDarkMode)}
        value={value ? value : null}
        onChange={onChange}
        options={options}
        components={{DropdownIndicator}}
        maxMenuHeight={maxMenuHeight}
        placeholder={placeholder}
        noOptionsMessage={() => noOptionsMessage || t('general.no-options')}
      />
    </div>
  );
};

export default SimpleSelect;

SimpleSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
      value: PropTypes.string,
    })
  ),
  maxMenuHeight: PropTypes.number,
  placeholder: PropTypes.string,
  isRequired: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.any,
  noOptionsMessage: PropTypes.string,
  isDisabled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  isError: PropTypes.bool,
};

SimpleSelect.defaultProps = {
  options: [],
  maxMenuHeight: 300,
  placeholder: '',
  onChange: () => {},
  isDisabled: false,
  isError: false,
};
